// extracted by mini-css-extract-plugin
export var dropdownButton = "_2l-0";
export var fullWidthDropdownButton = "_2l-1";
export var icon = "_2l-3";
export var iconPlaceholder = "_2l-2";
export var menuItemRow = "_2l-9";
export var separator = "_2l-e";
export var shortcutContainer = "_2l-7";
export var shortcutContainerFilled = "_2l-8";
export var shortcutIconLg = "_2l-6";
export var shortcutIconMd = "_2l-5";
export var shortcutIconSm = "_2l-4";
export var submenuChevron = "_2l-d";
export var submenuDropdown = "_2l-a";
export var submenuTriggerRow = "_2l-b";
export var submenuTriggerRowOpen = "_2l-c";